import styled, { css } from 'styled-components';
import { FONT_TYPES, token, typographyMixin } from '@zillow/constellation';

import { MUIBreakpointLg, MUIBreakpointXl } from '../../constants';

export const StyledHeaderSubNav = styled.div`
  display: none;
  z-index: 275; /* same as SOH z-index */
  justify-content: center;
  height: 50px;
  background: ${token('colors.white')};
  border-bottom: 1px solid ${token('colors.gray300')};
  box-sizing: border-box;

  @media screen and (min-width: ${MUIBreakpointLg}) {
    display: flex;
  }
`;

export const StyledButtonContainer = styled.div`
  height: 50px;
  margin-left: auto;
  margin-right: 0px;
`;

export const StyledContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 1280px;
  padding: 0 24px;

  @media screen and (min-width: ${MUIBreakpointXl}) {
    padding: 0;
  }
`;

export const StyledTab = styled.div<{ isActive?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  margin-right: 32px;
  border-top: 3px solid transparent;

  ${({ isActive }) =>
    css`
      border-bottom: 3px solid ${isActive ? token('colors.brand') : 'transparent'};
    `}
`;

export const StyledSubTabContainer = styled.div<{ isVisible: boolean }>`
  ${({ isVisible }) => !isVisible && 'display: none;'}
  position: absolute;
  top: 46px;
  left: -16px;
  background: ${token('colors.white')};
  border-left: 1px solid ${token('colors.gray300')};
  border-right: 1px solid ${token('colors.gray300')};
  min-width: 200px;
  z-index: 2;
`;

export const StyledSubTab = styled.div`
  height: 50px;
  padding: 12px 16px;
  border-bottom: 1px solid ${token('colors.gray300')};
`;

export const StyledSubNavLink = styled.a`
  text-decoration: none;
  white-space: nowrap;
  cursor: pointer;
  color: ${token('colors.textDark')};
  line-height: 24px;

  ${(props) => typographyMixin({ ...props, fontType: FONT_TYPES.bodySmall })}

  &:hover {
    color: ${token('colors.brand')};
  }
`;

export const StyledSubNavTabTitle = styled.span<{
  isActive?: boolean;
}>`
  ${({ isActive }) =>
    isActive &&
    css`
      ${(props) => typographyMixin({ ...props, fontType: FONT_TYPES.bodySmallHeading })}
      color: ${token('colors.brand')};
    `}
`;
